import { __decorate, __metadata } from 'tslib';
import { NotEnumerable } from '@tencent/workbench-core';
import { ProviderStorable } from '../../core/provider-storable.js';

/**
 * @internal
 */
class FeatureProvider extends ProviderStorable {
    constructor(provide) {
        super(provide);
        this.adapters = [];
        this.mounted = false;
        this.lifeCycleCount = 0;
        this.type = 'feature';
    }
    onOpen() {
        this.lifeCycleCount += 1;
    }
    onClose() {
        this.lifeCycleCount -= 1;
    }
    isNotClosed() {
        return this.lifeCycleCount !== 0;
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Array)
], FeatureProvider.prototype, "adapters", void 0);

export { FeatureProvider };
//# sourceMappingURL=feature-provider.js.map
